import { Badge, TextStyle } from '@superops/ui-design-system';
import React from 'react';
import { SVGIcon } from '@superops/super-icons';

const ICON_MAP = {
  ACTIVE: 'ActiveClient',
  PROSPECT: 'Prospect',
  INACTIVE: 'InactiveClient'
};

const STATUS_MAP = {
  stage: {
    ACTIVE: 'success',
    INACTIVE: 'critical',
    PROSPECT: 'info'
  },
  status: {
    LOST: 'critical',
    PAID: 'success',
    NEGOTIATION: 'warning',
    UNPAID: 'critical',
    NEW: 'info',
    WON: 'success'
  }
};
const BadgeCell = (props) => {
  const cell = props?.cell;
  const value = cell?.value;
  const accessorKey = cell?.column?.accessorKey;
  const fieldOptions = cell?.column?.fieldOptions;
  const currentValue = fieldOptions?.find((field) => field?.value === value);
  const details = currentValue?.details;
  const constants = details?.constants;
  const getStatus = () => {
    return STATUS_MAP?.[accessorKey]?.[constants];
  };
  const status = details?.status || getStatus();
  const icon =
    accessorKey === 'stage' ? ICON_MAP?.[constants] || 'CustomStatus' : null;

  if (!value) {
    return <TextStyle variation="subdued">NA</TextStyle>;
  }
  return (
    <Badge
      icon={icon && <SVGIcon name={icon} />}
      iconPosition="left"
      status={status}
    >
      <TextStyle>{value || 'NA'}</TextStyle>
    </Badge>
  );
};

export default BadgeCell;
